module.exports = __webpack_public_path__ + "img/apaaslog.1a530069.png";